import {fetchChartPalette, fetchDefaultTheme, fetchReport} from './themeService';
import {selectDefaultTheme, selectThemeById} from './themeSelectors';
import * as AppConstants from '../../app/AppConstants';

export const loadThemeByReportId = reportId => (dispatch, getState) => {
  if (selectThemeById(getState(), reportId)) return Promise.resolve();

  return fetchReport(reportId).then(response => {
    const {id, type} = response.theme.chartColorPalette;
    fetchChartPalette(id, type).then(chartPalette => {
      dispatch({
        type: AppConstants.THEME__LOAD_FINISHED,
        payload: {
          themeId: reportId,
          theme: response.theme,
          chartPalette,
        },
      });
    });

  });
};

export const loadDefaultTheme = () => (dispatch, getState) => {
  if (selectDefaultTheme(getState())) return Promise.resolve();

  return fetchDefaultTheme().then(response => {
    const {id, type} = response.chartColorPalette;
    fetchChartPalette(id, type).then(chartPalette => {
      dispatch({
        type: AppConstants.THEME__LOAD_FINISHED,
        payload: {
          themeId: 'default',
          theme: response,
          chartPalette,
        },
      });
    });

  });
}
